import { render, staticRenderFns } from "./payment-artifact-header.vue?vue&type=template&id=1c859982&scoped=true&"
import script from "./payment-artifact-header.vue?vue&type=script&lang=js&"
export * from "./payment-artifact-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c859982",
  null
  
)

export default component.exports